import { Avatar, useTheme } from "@mui/material";
import ExtensionIcon from "@mui/icons-material/Extension";
import { useGetImage } from "./customHooks";

export default function ServiceImage({ service, isAvatar, imageSize }) {
  const image = useGetImage(service.image);
  const theme = useTheme();
  if (!isAvatar) {
    return service?.image ? (
      <img
        alt=""
        style={{
          objectFit: "scale-down",
          maxHeight: "100%",
          maxWidth: "100%",
        }}
        src={image}
      />
    ) : (
      <ExtensionIcon
        sx={{ fontSize: "42px", color: theme.palette.success.main }}
      />
    );
  } else {
    return (
      <Avatar
        variant="rounded"
        src={image}
        sx={{
          width: imageSize,
          height: imageSize,
          bgcolor: "transparent",
        }}
      >
        <ExtensionIcon
          sx={{
            fontSize: imageSize / 1.5,
            color: theme.palette.success.main,
          }}
        />
      </Avatar>
    );
  }
}
